export enum LogLevel {
    INFO = 'INFO',
    WARNING = 'WARNING',
    ERROR = 'ERROR'
  }
  
  export const logger = (component: string, message: string, level: LogLevel = LogLevel.INFO) => {
    console.log(`[${component}] [${level}] ${message}`);
  };